var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dark-toast-wrapper"},[_c('div',{staticClass:"dark-toast-body"},[_c('p',[_vm._v(_vm._s(_vm.content))]),(_vm.clickText)?_c('span',{on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.clickText))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }